import React from 'react';
import { connect } from 'react-redux';
import logger from 'redux-logger';
import '../src/assests/css/bootstrap.min.css';
import '../src/assests/css/master.css';
import '../src/assests/css/calendar.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import history from './auth/history';
import AddSender from './components/SenderComponent/AddSender';
import Sender from './components/SenderComponent/Sender';
import SenderDetails from './components/SenderComponent/SenderDetails';
import SenderReview from './components/SenderComponent/SenderReview';
import BeneficiaryDetails from './components/BeneficiaryComponent/BeneficiaryDetails';
import MoneyTransferDetails from './components/MoneyTransferComponent/MoneyTransferDetails';
import ReviewMoneyTransfer from './components/MoneyTransferComponent/ReviewMoneyTransfer';
import ReviewAddBeneficiary from './components/BeneficiaryComponent/ReviewAddBeneficiary';
import SendersList from './components/SenderComponent/SendersList';
import SearchIfsc from './components/BeneficiaryComponent/SearchIfsc';
import Login from './components/LoginComponent/Login';
import MoneyTransfer2 from './components/MoneyTransferComponent/MoneyTransfer2';
import MoneyTransferOtp from './components/MoneyTransferComponent/MoneyTransferOtp';
// import AddBenefisciaryAfterIFSC from './components/BeneficiaryComponent/AddBenefisciaryAfterIFSC';
import { InactiveAlertModal, LogoutModal } from './components/LoginComponent/LogOutModal';
import { store } from './redux/store';
import { resetMiscData, setActiveStatus, setLogOutWarningStatus } from './redux/misc-data/misc-data.action';
import moment from 'moment';
import { LogOutWarning } from './components/LoginComponent/LogOutWarning';
import Logout from './components/LoginComponent/Logout';
import Dashboard2 from './components/DashboardComponent/Dashboard2';
import AddBenefisciaryFinal from './components/BeneficiaryComponent/AddBenefisciaryFinal';
import ErrorPage from './components/LoginComponent/ErrorPage';
import Test from './components/TestComponents/Test';
import BenefisciaryVerification from './components/BeneficiaryComponent/BenefisciaryVerification';
import Recharge from './components/RechargeComponent/Recharge';
import RechargeMoneyTransfer from './components/RechargeComponent/RechargeMoneyTransfer';
import DTHMoneyTransfer from './components/RechargeComponent/DTHMoneyTransfer';
import RechargeDetails from './components/RechargeComponent/RechargeDetails';
import RechargeAllTxn from './components/RechargeComponent/RechargeAllTxn';
import MoneyTransferDetails1 from './components/MoneyTransferComponent/moneytransferdetailstest';
import BillPay from './components/BillPayComponent/BillPay';
import BillPayMoneyTransfer from './components/BillPayComponent/BillPayMoneyTransfer';
import BillPayTransferDetails2 from './components/BillPayComponent/BillPayTransferDetails2';
import AEPS from './components/AEPSComponent/AEPS';
import BillPayAllTxn from './components/BillPayComponent/BillPayAllTxn';
import AepsTransfer from './components/AEPSComponent/AepsTransfer';
import config from "../src/config.js";
import Retailer from './components/KycComponent/RegisterRetailer';
import RegisterRetailer from './components/KycComponent/RegisterRetailer';
import VerifyOtp from './components/KycComponent/VerifyOtp';
import UploadID from './components/KycComponent/UploadID';
import AddBusinessDetails from './components/KycComponent/AddBusinessDetails';
import ReferralCode from './components/KycComponent/ReferralCode';
import RoDone from './components/KycComponent/RoDone';
import KycProcess from './components/KycComponent/KycProcess';
import KycStatus from './components/KycComponent/KycStatus';
import KycDetails from './components/KycComponent/KycDetails';
import CMSLOgin from './components/LoginComponent/CMSLOgin';
import TALOad from './components/TALoadComponent/TALOad';
import KycProcess2 from './components/KycComponent/KycProcess2';

import axios from 'axios';
import { setMerchantOnboardStatus, setOnboardActiveRoId, setOnboardActiveRoIdMap } from './redux/retailer-kyc-details/retailer-kyc-details.action';
import TransactionHistory from './components/MoneyTransferComponent/TransactionHistory';
import ClaimUpload from './components/ClaimComponent/ClaimUpload';
import ClaimDetails from './components/ClaimComponent/ClaimDetails';
import AccountHistory from './components/ClaimComponent/AccountHistory';
import TestAeps from './components/AEPSComponent/TestAeps';
import AEPSForm1 from './components/AEPSComponent/AEPSForm1';
import AepsAllTxn from './components/AEPSComponent/AepsAllTxn';
import FinxPayLogin from './components/LoginComponent/FinxPayLogin';
import MerchantPayout from './components/MerchantPayoutComponent/MerchantPayout';
import AddMerchantAccount from './components/MerchantPayoutComponent/AddMerchantAccount';
import AddAccountIfsc from './components/MerchantPayoutComponent/AddAccountIfsc';
import AccountDetails from './components/MerchantPayoutComponent/AccountDetails';
import ReviewAddAccount from './components/MerchantPayoutComponent/ReviewAddAccount';
import AccountVerrification from './components/MerchantPayoutComponent/AccountVerrification';
import UploadMerchantId from './components/MerchantPayoutComponent/UploadMerchantId';
import UploadMerchantTest from './components/MerchantPayoutComponent/UploadMerchantIdTest';
import Merchant from './components/MerchantPayoutComponent/Merchant';
import MerchantTransferDetails from './components/MerchantPayoutComponent/MerchantTransferDetails';
import MerchantPayoutReview from './components/MerchantPayoutComponent/MerchantPayoutReview';
import PayoutAllTxn from './components/MerchantPayoutComponent/PayoutAllTxn';
import AEPSCashWithdrawlDetails from './components/AEPSComponent/AEPSCashWithdrawlDetails';
import ResetOTP from './components/LoginComponent/ResetOTP';
import ResetPass from './components/LoginComponent/ResetPass';
import AddBankDetails from './components/KycComponent/AddBankDetails';
import RetailerIFSC from './components/KycComponent/RetailerIFSC';
import SetPassword from './components/KycComponent/SetPassword';
//  import { WebUSB } from 'usb';
const httpClient = axios.create();
class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      currentUser: null,
      timeout: 1000 * 1 * 1 * 60 * 30,
      // timeout:1000 *1*1*5,
      showModal: false,
      activeshowModal: false,
      warningshowModal: false,
      userLoggedIn: false,
      isTimedOut: false,
      alertActive: false
    };

    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  rdserviceTes(val) {
    var port;
    var urlStr = '';
    urlStr = 'http://localhost:' + val + '/';

  }
  getJSON_rd = (url) => {

    var xhr = new XMLHttpRequest();
    xhr.open('RDSERVICE', url, true);
    xhr.responseType = 'text';
    xhr.onload = function () {
      var status = xhr.status;
      if (status == 200) {
        alert(xhr.response)
        // callback(null, xhr.response);
      } else {
        alert(status)
        // callback(status);
      }
    };
    xhr.send();
  };


  _onAction(e) {
    // console.log('user did something', e)
    this.setState({ isTimedOut: false })
  }

  _onActive(e) {
    // console.log('user is active', e)
    this.setState({ isTimedOut: false })
  }

  _onIdle(e) {
    console.log('user is idle', e);
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      console.log('isTimedOut::::::::' + isTimedOut);
    } else {
      this.setState({ showModal: true })
      this.idleTimer.reset();
      //this.setState({isTimedOut: true})
    }

  }

  handleClose() {
    this.setState({ showModal: false })
  }

  activehandleClose() {
    store.dispatch(setActiveStatus('fasle'));

  }
  warninghandleClose() {
    // this.setState({warningshowModal: false})
    store.dispatch(setLogOutWarningStatus('fasle'));
    localStorage.setItem('warningcreationtime', new Date());
    localStorage.setItem('warningcreationstatus', 'true');
  }

  handleLogout() {
    history.push('/logout');
    history.go();


  }

  activehandleLogout() {
    history.push('/logout');
    history.go();
  }

  warninghandleLogout() {
    history.push('/logout');
    history.go();
  }

  calculateTimegap(logintime, status) {
    var loginTimeStamp = Date.parse(logintime);
    var momentval = new Date().getTime();
    var timeDiff = parseInt(momentval) - parseInt(loginTimeStamp);
    var secondsDifference = Math.floor(timeDiff / 1000);
    if (status == 'warning') {
      if (secondsDifference > (25 * 60)) {
        store.dispatch(setLogOutWarningStatus("true"));
        this.setState({
          warningshowModal: true
        })
      }
    }
    if (status == 'logout') {
      if (secondsDifference > (30 * 60)) {
        store.dispatch(setActiveStatus("true"));
        this.setState({
          warningshowModal: false,
          activeshowModal: false
        })
        history.push('/logout');
        history.go();
      }
    }

  }
  componentDidMount() {

    // usbDetect.startMonitoring();
    store.dispatch(setActiveStatus(''));
    store.dispatch(setLogOutWarningStatus(''));

    // store.dispatch(setOnboardActiveRoId(''));
    // store.dispatch(setOnboardActiveRoIdMap(''));

    // this.merchantOnboardCheck();


    var warningcreationtime = new Date(localStorage.getItem('warningcreationtime')).getTime();
    var curTime = new Date().getTime();
    // console.log('time....'+warningcreationtime+' '+curTime);

    var timeDiff = parseInt(curTime) - parseInt(warningcreationtime);
    // console.log(timeDiff);
    var secondsDifference = 0;
    if (parseInt(curTime) > parseInt(warningcreationtime)) {
      secondsDifference = Math.floor(timeDiff / 1000);
    }
    if (secondsDifference >= 300) {
      localStorage.clear();
    }
    var logintime = this.props.loginTime;
    var warningInterVal = '';
    var logOutInterVal = '';

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    //  window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });

  }
  merchantOnboardCheck = () => {
    var merchantOnboardStatusLoop = '';
    merchantOnboardStatusLoop = setInterval(() => {
      if (this.props.onboardActiveRoId != null && this.props.onboardActiveRoId != undefined &&
        this.props.onboardActiveRoId != '') {
        console.log('active roId for merchant Onbaord : ' + this.props.onboardActiveRoId);
        //if active ro Id exist then find merchant onboard ststus for next  5 min
        //if status is completed  ; end the loop
        //if loop takes more than 30 count; end the loop
        var map = this.props.onboardActiveRoIdMap;
        var count = parseInt(map.split(':')[1]);


        // var count = (map1.get(this.props.onboardActiveRoId));

        if (count <= 19) {
          this.verifyNerchantOnbaord(this.props.onboardActiveRoId);
        } else {
          console.log('checked more than ' + count + ' time');
          store.dispatch(setOnboardActiveRoId(''));
          store.dispatch(setOnboardActiveRoIdMap(new Map()));

        }

      } else {
        console.log('no active roId for merchant Onbaord');
      }
    }, 10000);
  }

  verifyNerchantOnbaord = (roId) => {
    // const headers = {
    //     'Authorization': 'Bearer ' + this.props.token,
    //     'client-id': this.props.agentInfo.id,
    //     'role': this.props.clientRole
    // }
    httpClient.get('/api/v1/paysprint/connector/kyc/whitelabel/enquiry/' +
      roId
      // { headers }
    ).then((response) => {
      console.log('merchant onbaord  enquiry Response' + JSON.stringify(response.data));
      if (response.data.merchantOnBoarStatus == 'completed') {
        store.dispatch(setOnboardActiveRoId(''));
        store.dispatch(setMerchantOnboardStatus('completed'));
      } else {
        var map = this.props.onboardActiveRoIdMap;
        var count = parseInt(map.split(':')[1]);
        count = count + 1;
        var valMap = roId + ':' + count;

        store.dispatch(setOnboardActiveRoIdMap(valMap));
        store.dispatch(setMerchantOnboardStatus('not-completed'));

      }

    }).catch(error => {
      var map = this.props.onboardActiveRoIdMap;
      var count = parseInt(map.split(':')[1]);
      count = count + 1;
      var valMap = roId + ':' + count;

      store.dispatch(setOnboardActiveRoIdMap(valMap));
      store.dispatch(setMerchantOnboardStatus('not-completed'));

      console.log(error.message);
    });

  }

  render() {

    // var userProfileResponseStatus=this.props.userProfileResponse==''?'blank':this.props.userProfileResponse==null?'null':'above value';
    // console.log('userProfileResponseStatus..',userProfileResponseStatus);
    return (


      <div>

        <Routes>

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='dmt' element={<Dashboard2 />}></Route> :
            <Route path='dmt' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='add-sender' element={<AddSender />}></Route> :
            <Route path='add-sender' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='transaction-history' element={<TransactionHistory />}></Route> :
            <Route path='transaction-history' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='add-beneficiary' element={<AddBenefisciaryFinal />}></Route> :
            <Route path='add-beneficiary' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {/* {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='add-beneficary' element={<AddBenefisciaryAfterIFSC />}></Route> :
            <Route path='add-beneficary' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          } */}

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='beneficiary-details' element={<BeneficiaryDetails />}></Route> :
            <Route path='beneficiary-details' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='money-transfer' element={<MoneyTransfer2 />}></Route> :
            <Route path='money-transfer' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }Bene

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='money-transfer-review' element={<MoneyTransferOtp />}></Route> :
            <Route path='money-transfer-review' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='money-transfer-details' element={<MoneyTransferDetails />}></Route> :
            <Route path='money-transfer-details' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='review-money-transfer' element={<ReviewMoneyTransfer />}></Route> :
            <Route path='review-money-transfer' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='review-add-beneficiary' element={<ReviewAddBeneficiary />}></Route> :
            <Route path='review-add-beneficiary' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='beneficiary-verify' element={<BenefisciaryVerification />}></Route> :
            <Route path='beneficiary-verify' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='search-ifsc' element={<SearchIfsc />}></Route> :
            <Route path='search-ifsc' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='sender' element={<Sender />}></Route> :
            <Route path='sender' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='sender-details' element={<SenderDetails />}></Route> :
            <Route path='sender-details' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='sender-review' element={<SenderReview />}></Route> :
            <Route path='sender-review' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }


          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='senders-list' element={<SendersList />}></Route> :
            <Route path='senders-list' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          <Route path='/403' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='recharge' element={<Recharge />}></Route> :
            <Route path='recharge' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='recharge-money-transfer' element={<RechargeMoneyTransfer />}></Route> :
            <Route path='recharge-money-transfer' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='recharge-details' element={<RechargeDetails />}></Route> :
            <Route path='recharge-details' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path="recharge-txn" element={<RechargeAllTxn />}></Route> :
            <Route path='recharge-txn' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='billpay' element={<BillPay />}></Route> :
            <Route path='billpay' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='billpay-transfer' element={<BillPayMoneyTransfer />}></Route> :
            <Route path='billpay-transfer' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='billpay-details' element={<BillPayTransferDetails2 />}></Route> :
            <Route path='billpay-details' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='billpay-txn' element={<BillPayAllTxn />}></Route> :
            <Route path='billpay-txn' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }


          {/* {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
             <Route path='aeps' element={<AEPS />}></Route> :
             <Route path='aeps' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          } */}

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='aeps' element={<AEPS />}></Route> :
            <Route path='aeps' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          <Route path='test-aeps' element={<AEPSForm1 />}></Route>
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='aeps-alltxn' element={<AepsAllTxn />}></Route> :
            <Route path='aeps-alltxn' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='aeps-transfer' element={<AepsTransfer />}></Route> :
            <Route path='aeps-transfer' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
           {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='aeps-cashwithdrawl' element={<AEPSCashWithdrawlDetails />}></Route> :
            <Route path='aeps-cashwithdrawl' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

     
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='merchant-onboard' element={<KycProcess2 />}></Route> :
            <Route path='merchant-onboard' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
           {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='yesbank-kyc' element={<KycProcess />}></Route> :
            <Route path='yesbank-kyc' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='merchant-payout' element={<Merchant />}></Route> :
            <Route path='merchant-payout' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='add-account' element={<AddMerchantAccount />}></Route> :
            <Route path='add-account' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='account-ifsc' element={<AddAccountIfsc />}></Route> :
            <Route path='account-ifsc' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='account-details' element={<AccountDetails />}></Route> :
            <Route path='account-details' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='review-add-account' element={<ReviewAddAccount />}></Route> :
            <Route path='review-add-account' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='account-verify' element={<AccountVerrification />}></Route> :
            <Route path='account-verify' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='doc-upload' element={<UploadMerchantId />}></Route> :
            <Route path='doc-upload' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='payout-transfer' element={<MerchantTransferDetails />}></Route> :
            <Route path='payout-transfer' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }
          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='payout-review' element={<MerchantPayoutReview />}></Route> :
            <Route path='payout-review' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          {(this.props.agentInfo != null && this.props.agentInfo != '' && this.props.agentInfo != undefined) ?
            <Route path='payout-txn' element={<PayoutAllTxn />}></Route> :
            <Route path='payout-txn' element={<ErrorPage title='403 error!' description='Sorry! You cannot access the page' />}></Route>
          }

          <Route path='register-retailer' element={<RegisterRetailer />}></Route>
          <Route path='verify-otp-retailer' element={<VerifyOtp />}></Route>
          <Route path='upload-retailer' element={<UploadID />}></Route>
          <Route path='add-business-details' element={<AddBusinessDetails />}></Route>
          <Route path='retailer-bank' element={<AddBankDetails />}></Route>
          <Route path='retailer-ifsc' element={< RetailerIFSC/>}></Route>
          <Route path='set-password' element={< SetPassword/>}></Route>
          <Route path='referral-code' element={<ReferralCode />}></Route>
          <Route path='ro-done' element={<RoDone />}></Route>
          {/* <Route path='kyc-process' element={<KycProcess/>}></Route> */}

          <Route path='kyc-status' element={<KycStatus />}></Route>
          <Route path='kyc-details' element={<KycDetails />}></Route>
          {/* <Route path='/cms-login' element={<CMSLOgin />}></Route> */}
          <Route path='/finxpay-login' element={<FinxPayLogin />}></Route>
          <Route path='/reset-otp' element={<ResetOTP />}></Route>
          <Route path='/reset-password' element={<ResetPass />}></Route>
          <Route path='/taload' element={<TALOad />}></Route>
          <Route path='/claim-upload' element={<ClaimUpload />}></Route>
          <Route path='/claim-details' element={<ClaimDetails />}></Route>
          <Route path='/account-history' element={<AccountHistory />}></Route>
          <Route path='/whitelabel' element={<Login />}></Route>
          <Route path='/whitelabel/login' element={<Login />}></Route>
          <Route path='/test' element={<TestAeps />}></Route>
	  <Route path='test-upload' element={<UploadMerchantTest />}></Route>
          <Route path='/logout' element={<ErrorPage title='Session time-out' description='Sorry! Your session is over.You will be redirected to Client Page' />}></Route>
          {/* <Route  path='/test' element={<Test/>}></Route> */}

          <Route path="*" element={<ErrorPage title='404 error!' description='Sorry! This page does not exist' />} />
        </Routes>



      </div >
    )
  }
}




const mapStateToProps = (
  { errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, deviceInfo, token, activeStatus, logOutWarningStatus, agentInfo,
      loginTime, timeoutModal },
    authReduce: { callBackUrl },
    retailerKycReduce: { onboardActiveRoId, onboardActiveRoIdMap } }
  ,
) => ({
  errorMessage, loginErrorMessage, phone, deviceInfo, token, activeStatus, logOutWarningStatus, agentInfo,
  loginTime, timeoutModal, callBackUrl, onboardActiveRoId, onboardActiveRoIdMap
});


export default connect(mapStateToProps, null)(App);
